import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Arrow from '../../assets/image/icon/arrow.png'

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;

  .scroll-to-top-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0 10px 10px;

    span {
      color: #323333;
      font-size: 10px;
      margin-right: 10px;
    }
    img {
      width: 15px;
      height: 15px;
    }
  }
`;

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  // ページのスクロール位置を監視し、ボタンの表示・非表示を切り替える
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    setShowButton(scrollTop > 0);
  };

  // ボタンをクリックしたときに上にスクロールする
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // スクロールイベントを追加
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Wrapper>
      <button
        className={`scroll-to-top-button ${showButton ? 'show' : 'hide'}`}
        onClick={scrollToTop}
      >
        <span>上部へ戻る</span>
        <img src={Arrow} alt="上部へ戻る" />
      </button>
    </Wrapper>
  );
};

export default ScrollToTopButton;
